/**
 * Credits as shown next to a credit icon: integers as-is, a fractional rate (a custom
 * audience rate times a multiplier) rounded to two decimals so float noise never shows.
 */
export function formatCreditAmount(value: number): string {
  return String(Math.round(value * 100) / 100)
}
